module.exports = __webpack_public_path__ + "static/media/7-1.d9dc55c5.webp";